import React from "react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";
import banner1 from "../../../xyz123.png";
import banner2 from "../../../xyz3.webp";
import rumicon1 from "../../../teacup.png";
import rumicon2 from "../../../momo.png";
import janakpurbg from "../../../janakpur.jpg";
import lumbinibg from "../../../lumbinibg.png";
import rumicon3 from "../../../spicesicon.png";
import rumicon4 from "../../../monkmed.png";
import "./Navbar.css";
import "./BasicExample.css";
import newspaperbg from "../../../newspaperbg.jpg";
import Khukuri from "../../../Khukuri.png";
import Century from "../../../centurylogo.png";
import Coffee88 from "../../../coffeelogoo.png";
import logonepalice from "../../../beerimg.png";
import haamilogo from "../../../haamilogo.svg";
import Marquee from "react-fast-marquee";
import Coffee88logo from "../../../coffee88.png";
import purelogo from "../../../purelogo.avif";
import barasinghelogo from "../../../barasinghelogo.png";
import productsbg from "../../../productsbg.jpg";

const HeroSection = () => {
  const location = useLocation();
  const isHome = location.pathname === "/"; // ✅ Move this ABOVE useEffect
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!isHome) {
        setScrollY(window.scrollY);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);

  // if (location.pathname === "/Newsevent") return null;
  // if (location.pathname === "/contact") return null;

  // 🔽 Map paths to titles and subtitles
  const titleMap = {
    "/aboutpage": {
      heading: "About Us",
      subheading: "Learn more about our journey and values",
    },
    "/gallery": {
      heading: "Taste Wear & Feel Nepal",
      subheading:
        "Bold drinks, earthy spices, ethical fashion — everything crafted with soul and story.",
    },
    "/Newsevent": {
      heading: "News & Events",
      subheading: "Stay updated with the latest happenings",
    },
    "/contact": {
      heading: "Contact Us",
      subheading: "We’re here to help — let’s connect",
    },
  };

  // 🔽 Default to fallback title if page not listed
  const pageContent = titleMap[location.pathname] || {
    heading: "Welcome",
    subheading: "Explore our website",
  };

  let backgroundImage = banner1; // default

  if (location.pathname.includes("/aboutpage")) {
    backgroundImage = janakpurbg;
  } else if (location.pathname.includes("/contact")) {
    backgroundImage = lumbinibg;
  } else if (location.pathname.includes("/gallery")) {
    backgroundImage = productsbg;
  } else if (location.pathname.includes("/Newsevent")) {
    backgroundImage = newspaperbg;
  }

  return (
    <div className="main-banner">
      {isHome ? (
        <Carousel fade>
          <Carousel.Item>
            <img className="d-block w-100" src={banner1} alt="First slide" />
            <Carousel.Caption>
              <div className="hero-text text-center">
                <h1 className="h1">Himalayas In You !</h1>
              </div>
            </Carousel.Caption>
            <div className="carousel-overlay-image1">
              <img src={rumicon1} alt="Overlay" className="overlay-image-1" />
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <img className="d-block w-100" src={banner2} alt="Second slide" />
            <Carousel.Caption>
              <div className="hero-text">
                <h1>Himalayas In You !</h1>
              </div>
            </Carousel.Caption>
            <div className="carousel-overlay-image2">
              <img src={rumicon2} alt="Overlay" className="overlay-image-2" />
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <img className="d-block w-100" src={janakpurbg} alt="Third slide" />
            <Carousel.Caption>
              <div className="hero-text">
                <h1>Himalayas In You !</h1>
              </div>
            </Carousel.Caption>
            <div className="carousel-overlay-image3">
              <img src={rumicon3} alt="Overlay" className="overlay-image-3" />
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <img className="d-block w-100" src={lumbinibg} alt="Fourth slide" />
            <Carousel.Caption>
              <div className="hero-text">
                <h1>Himalayas In You !</h1>
              </div>
            </Carousel.Caption>
            <div className="carousel-overlay-image4">
              <img src={rumicon4} alt="Overlay" className="overlay-image-4" />
            </div>
          </Carousel.Item>
        </Carousel>
      ) : (
        <div
          key={location.pathname} // ⬅️ triggers remount
          className="single-banner-wrapper position-relative text-center"
        >
          <div
            className="parallax-banner"
            style={{ backgroundImage: `url(${backgroundImage})` }}
          ></div>

          <div className="banner-overlay"></div>
          <div
            className="overlay-text"
            style={{
              transform: `translate(-50%, calc(-50% + ${scrollY * 0.2}px))`,
            }}
          >
            <h1 className="hero-heading">{pageContent.heading}</h1>
            <p className="hero-subheading">{pageContent.subheading}</p>
            {location.pathname === "/gallery" && (
              <div className="marquee-wrapper mt-4">
                <Marquee gradient={false} speed={50} pauseOnHover={false}>
                  {[
                    haamilogo,
                    Century,
                    Coffee88logo,
                    Khukuri,
                    purelogo,
                    barasinghelogo,
                  ].map((logo, index) => (
                    <img
                      key={index}
                      src={logo}
                      alt={`logo-${index}`}
                      style={{
                        height: "90px",
                        width: "170px",
                        margin: "0 30px",
                        objectFit: "contain",
                      }}
                    />
                  ))}
                </Marquee>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default HeroSection;
